export const asyncImportSVG = async (name) => await import(`./icons/${name}.js`);
//# sourceMappingURL=asyncImportSVG.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
